import type { Version } from '@atlassian/jira-issue-shared-types';
import { VersionStatus } from '../constants';
import type { AggVersionNode } from '../types';

type VersionWithARI = { ari: string } & Version;

export const transformAggVersionToLegacyVersionOld = (
	version: Pick<AggVersionNode, 'versionId' | 'name' | 'description' | 'status'>,
): Version => ({
	id: version.versionId ?? '',
	name: version.name ?? '',
	description: version.description ?? '',
	archived: version.status === VersionStatus.ARCHIVED,
	released: version.status === VersionStatus.RELEASED,
});

export const transformAggVersionToLegacyVersion = (
	version: Pick<AggVersionNode, 'versionId' | 'name' | 'description' | 'status' | 'id'>,
): VersionWithARI => ({
	id: version.versionId ?? '',
	name: version.name ?? '',
	description: version.description ?? '',
	archived: version.status === VersionStatus.ARCHIVED,
	released: version.status === VersionStatus.RELEASED,
	ari: version.id,
});
